<script>
    import PageIndex from "../core/page-index";
    export default {
        components: {PageIndex}
    }
</script>
<template>
    <page-index :url="`/admin/portal/wallets/${$route.params.id}/statement`" prefix="list" name="Statement">
        <template slot="sort-fields">
            <option value="created_at">Created</option>
            <option value="updated_at">Updated</option>
        </template>
        <template slot="table-header">
            <th></th>
            <th>#</th>
            <th>Date</th>
            <th>Description</th>
            <th>Currency</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Balance</th>
            <th></th>
        </template>
        <template slot="table-row" slot-scope="data">
            <td></td>
            <td>#{{ data.row.id }}</td>
            <td>{{ data.row.created_at }}</td>
            <td>{{ data.row.description }}</td>
            <td>{{ data.row.currency }}</td>
            <td>{{ data.row.type }}</td>
            <td>{{ data.row.amount }}</td>
            <td>{{ data.row.balance }}</td>
            <td></td>
        </template>
    </page-index>
</template>
